import { render, staticRenderFns } from "./share-playlist.vue?vue&type=template&id=fa4d5aae"
import script from "./share-playlist.vue?vue&type=script&lang=js"
export * from "./share-playlist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports